export const FETCH_BANKS_END = 'fetchBanksEnd'
export const FETCH_BANKS_START = 'fetchBanksStart'

//STORE
export const SET_BANKS = 'setBanks'

//COMPANY
export const SET_COMPANY_BANKS = 'setCompanyBanks'
